import type { CreditPackagePageVo, PlanPageVo } from "@/api";
import { fetchActivePlans, fetchCreditPackages } from "@/service/plans";
import { action, makeObservable, observable, runInAction } from "mobx";

export class PricingStore {
  @observable planPage: PlanPageVo = { planList: [] };
  @observable creditPackages: CreditPackagePageVo = { creditPackageList: [] };
  @observable loading: boolean = false;
  @observable loaded: boolean = false;

  constructor() {
    makeObservable(this);
  }

  @action async fetchPricingData() {
    // 避免重复请求
    if (this.loading || this.loaded) {
      return;
    }

    this.loading = true;

    try {
      const [planPageResult, creditPackagesResult] = await Promise.all([
        fetchActivePlans(),
        fetchCreditPackages(),
      ]);

      runInAction(() => {
        this.planPage = planPageResult ?? { planList: [] };
        this.creditPackages = creditPackagesResult ?? { creditPackageList: [] };
        this.loaded = true;
      });
    } catch (error) {
      console.error("Failed to fetch pricing data:", error);
    } finally {
      this.loading = false;
    }
  }

  @action hydrate(
    planPage: PlanPageVo = { planList: [] },
    creditPackages: CreditPackagePageVo = { creditPackageList: [] }
  ) {
    this.planPage = planPage;
    this.creditPackages = creditPackages;
    this.loaded = true;
    this.loading = false;
  }

  @action reset() {
    this.planPage = { planList: [] };
    this.creditPackages = { creditPackageList: [] };
    this.loaded = false;
    this.loading = false;
  }
}

export const pricingStore = new PricingStore();
